<template>
  <div>
    <v-dialog
      max-width="800"
      persistent
      transition="dialog-bottom-transition"
      v-model="showDialog"
    >
      <v-card :loading="loading">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Set to Image</v-toolbar-title>
        </v-toolbar>
        <v-card flat v-if="!listShowcases">
          <v-card-text>
            <v-alert type="warning">
              No Showcases found!
            </v-alert>
          </v-card-text>
        </v-card>
        <v-card flat v-if="listShowcases">
          <v-card-title>
            Select Showcase Image
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="6">
                <v-select
                  class="image-select"
                  v-model="showcaseSelect"
                  :items="listShowcases"
                  label="Showcase"
                  @change="setAvailableImages"
                >
                </v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="selectedImage"
                  v-bind:items="availableImages"
                  class="image-select"
                  label="Image"
                >
                </v-select
              ></v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat>
          <v-card-title>
            Run Options
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="3">
                <v-radio-group v-model="scheduleOrNow" :mandatory="true">
                  <v-radio label="Run now" value="now"></v-radio>
                  <v-radio label="Schedule" value="schedule"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="9">
                <CloudWatchCronExpressionBuilder
                  v-model="scheduleExpression"
                  v-if="schedule"
                  show-next-events="5"
                >
                </CloudWatchCronExpressionBuilder>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-btn @click="runOperation()" :disabled="selectedImage === null"
            >Run</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  SET_TO_IMAGE,
  SCHEDULE_SET_TO_IMAGE,
  LIST_SHOWCASES,
  LIST_SHOWCASE_IMAGES
} from '@/domain/showcases/constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import CloudWatchCronExpressionBuilder from '@/components/CWCronExpressionBuilder/CloudWatchCronExpressionBuilder'
import moment from 'moment'
import { isScheduleOnceType } from '@/domain/showcases/util/schedule'

export default {
  name: 'SetToImage',
  components: {
    CloudWatchCronExpressionBuilder
  },
  data: () => ({
    showDialog: true,
    loading: false,
    scheduleOrNow: 'now',
    scheduleExpression: '',
    message: null,
    availableImages: [],
    selectedImage: null,
    showcaseSelect: null,
    listShowcases: [],
    listShowcasesErrors: null
  }),
  props: ['showcase'],
  computed: {
    schedule: function() {
      return this.scheduleOrNow === 'schedule'
    }
  },
  methods: {
    setAvailableImages() {
      this.$apolloProvider.clients[DOMAIN_NAME].query({
        query: LIST_SHOWCASE_IMAGES,
        variables: {
          showcaseId: this.showcaseSelect
        },
        fetchPolicy: 'network-only'
      })
        .then(response => {
          this.availableImages = response.data.listImages
            .sort((a, b) => {
              return new Date(b.snapshotDate) - new Date(a.snapshotDate)
            })
            .map(image => {
              return {
                text: `${image.imageName} (${this.formatDate(
                  image.snapshotDate
                )})`,
                value: image.imageName
              }
            })
        })
        .catch(err => (this.listShowcasesErrors = err))
    },
    runOperation() {
      this.message = 'Starting Operation'

      let operationHandler =
        this.scheduleOrNow === 'now'
          ? this.operationHandler
          : this.scheduleOperationHandler
      this.message = 'Starting Operation'
      operationHandler()
        .then(response => {
          this.loading = false
          this.message = 'Success!'
          this.closeDialog()
        })
        .catch(err => {
          this.loading = false
          this.message = err
        })
    },
    async operationHandler() {
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: SET_TO_IMAGE,
        variables: {
          showcaseId: this.showcase.showcaseId,
          imageName: this.selectedImage
        },
        fetchPolicy: 'no-cache'
      })
    },
    async scheduleOperationHandler() {
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: SCHEDULE_SET_TO_IMAGE,
        variables: {
          showcaseId: this.showcase.showcaseId,
          imageName: this.selectedImage,
          scheduleExpression: 'cron(' + this.scheduleExpression + ')',
          scheduleType: isScheduleOnceType(this.scheduleExpression)
            ? 'ONCE'
            : 'PERIODIC'
        },
        fetchPolicy: 'no-cache'
      })
    },
    closeDialog() {
      this.$emit('close')
    },
    formatDate: function(date) {
      return moment
        .utc(date)
        .local()
        .format('DD.MM.YY, HH:mm:ss')
    }
  },
  apollo: {
    $client: DOMAIN_NAME,
    listShowcases: {
      query: LIST_SHOWCASES,
      result({ data, loading, networkStatus }) {
        this.listShowcases = data.listShowcases.showcases.map(showcase => {
          return {
            text: `${showcase.name} (${showcase.showcaseId})`,
            value: showcase.showcaseId
          }
        })
      },
      error(error) {
        this.listShowcasesError = JSON.stringify(error.message)
      }
    }
  }
}
</script>

<style scoped>
.image-select {
  width: 80%;
}
</style>
